import React, { useState } from 'react';
import './NewMesa.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewMesa() {
    const [mensaje, setMensaje] = useState('');
    const [numero, setNumero] = useState('');
    const [capacidad, setCapacidad] = useState('');
    const [estado, setEstado] = useState('disponible');
    const [descripcion, setDescripcion] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setNumero('');
        setCapacidad('');
        setEstado('disponible');
        setDescripcion('');
        setMensaje('');
        setModalOpen(!modalOpen);
    };

    const crear = async () => {
        if (!numero || !capacidad) {
            toast.error('Número y capacidad son requeridos');
            return;
        }

        const formData = new FormData();
        formData.append('numero', numero);
        formData.append('capacidad', capacidad);
        formData.append('estado', estado);
        formData.append('descripcion', descripcion);

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/mesasPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>+</span> Agregar Mesa
            </button>
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Nueva Mesa</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearMesaForm">
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Número de Mesa</legend>
                                    <input
                                        type='number'
                                        value={numero}
                                        onChange={(e) => setNumero(e.target.value)}
                                        placeholder='Ej: 1'
                                        min='1'
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Capacidad (personas)</legend>
                                    <input
                                        type='number'
                                        value={capacidad}
                                        onChange={(e) => setCapacidad(e.target.value)}
                                        placeholder='Ej: 4'
                                        min='1'
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select value={estado} onChange={(e) => setEstado(e.target.value)}>
                                        <option value='disponible'>Disponible</option>
                                        <option value='ocupada'>Ocupada</option>
                                        <option value='reservada'>Reservada</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Descripción (opcional)</legend>
                                    <input
                                        type='text'
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        placeholder='Ej: Terraza, ventana...'
                                    />
                                </fieldset>
                            </div>
                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
